import React, { useContext } from 'react';
import { Box } from 'vindi-ds-components';
import { Outlet } from 'react-router-dom';
import { AdminContext } from '@contexts/admin_context';
import useToggle from '@hooks/feature_toggles';
import CadastralUpdateForm from './CadastralUpdateCard';
import styles from './styles';

function CadastralUpdateModal() {
  const toggle = useToggle('merchant_contact_tab');
  const { showModal } = useContext(AdminContext);

  if (toggle && showModal) {
    return (
      <>
        <Box css={styles.modalStyle}>
          <CadastralUpdateForm />;
        </Box>
        <Outlet />
      </>
    );
  }

  return <Outlet />;
}

export default CadastralUpdateModal;
